import { render } from "./BannerSwiper.vue?vue&type=template&id=3c9506ba&scoped=true&ts=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=ts"
export * from "./BannerSwiper.vue?vue&type=script&lang=ts"

import "@/assets/scss/home/banner-swiper.scss?vue&type=style&index=0&id=3c9506ba&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9506ba"]])

export default __exports__